import { createContext, useContext } from 'react';

export const AuthContext = createContext({
  currentUser: undefined,
  isLoading: false,
  isLoggedIn: () => {},
  setCurrentUser: () => {},
  setIsLoggedIn: () => {}
});

export const useAuthContext = () => useContext(AuthContext);

export default AuthContext;
